import type { Localized } from "./types";

/** Chrome around the content: nav, section labels, buttons. */
export const ui = {
  navWork: { en: "Work", pt: "Projetos" },
  navExperience: { en: "Experience", pt: "Experiência" },
  navSkills: { en: "Skills", pt: "Competências" },
  navAbout: { en: "About", pt: "Sobre" },
  navContact: { en: "Contact", pt: "Contato" },

  skipToContent: { en: "Skip to content", pt: "Ir para o conteúdo" },
  primaryNav: { en: "Primary", pt: "Principal" },

  availableForWork: { en: "Available for work", pt: "Disponível para trabalho" },
  knownFor: { en: "What I'm known for: ", pt: "Sou conhecido por: " },
  resume: { en: "Resume", pt: "Currículo" },
  resumePdf: { en: "Resume (PDF)", pt: "Currículo (PDF)" },

  techStack: { en: "Technologies I work with", pt: "Tecnologias com que trabalho" },

  cookieTitle: { en: "Cookies", pt: "Cookies" },
  cookieMessage: {
    en: "This site uses Google Analytics to count visits. Nothing is loaded and no cookie is set unless you accept.",
    pt: "Este site usa o Google Analytics para contar visitas. Nada é carregado e nenhum cookie é criado sem a sua permissão.",
  },
  cookieAccept: { en: "Accept", pt: "Aceitar" },
  cookieDecline: { en: "Decline", pt: "Recusar" },
  cookieSettings: { en: "Cookie settings", pt: "Preferências de cookies" },

  selectedWork: { en: "Selected work", pt: "Trabalhos selecionados" },
  selectedWorkNote: {
    en: "Six things worth explaining in detail",
    pt: "Seis projetos que valem uma explicação detalhada",
  },
  alsoShipped: { en: "Also shipped", pt: "Também entreguei" },

  experience: { en: "Experience", pt: "Experiência" },
  experienceNote: { en: "2012 — present", pt: "2012 — hoje" },
  client: { en: "client", pt: "cliente" },

  skills: { en: "Skills", pt: "Competências" },
  skillsNote: {
    en: "Grouped by where they get used",
    pt: "Agrupadas por onde são usadas",
  },

  about: { en: "About", pt: "Sobre" },
  education: { en: "Education", pt: "Formação" },
  languages: { en: "Languages", pt: "Idiomas" },

  contact: { en: "Contact", pt: "Contato" },
  github: { en: "GitHub", pt: "GitHub" },

  colophon: {
    en: "Built with Vite, React and Tailwind. Static on S3 behind CloudFront, provisioned by Terraform, deployed by GitHub Actions on OIDC — no stored keys.",
    pt: "Feito com Vite, React e Tailwind. Estático no S3 atrás do CloudFront, provisionado com Terraform e publicado pelo GitHub Actions via OIDC — sem chaves armazenadas.",
  },

  present: { en: "Present", pt: "Hoje" },

  // The switcher shows the CURRENT language, so its accessible name has to say
  // what pressing it does.
  switchToPortuguese: { en: "Switch to Portuguese", pt: "Mudar para português" },
  switchToEnglish: { en: "Switch to English", pt: "Mudar para inglês" },
  languageLabel: { en: "Language", pt: "Idioma" },

  technologiesUsedOn: { en: "Technologies used on", pt: "Tecnologias usadas em" },
  technologiesUsedAt: { en: "Technologies used at", pt: "Tecnologias usadas na" },
} satisfies Record<string, Localized>;

export type UiKey = keyof typeof ui;
